export default __webpack_public_path__ + "img/mainav_appoinment.73322153.svg";